import type { EntryGenerator, PageLoad } from './$types';
import { error } from '@sveltejs/kit';
import { getWikiIndex, loadWikiComponent } from '$lib/features/wiki/logic/content';
import {
	listEntrySlugs,
	realTranslationHrefs,
	resolveWikiSlug,
	translationHrefs
} from '$lib/features/wiki/logic/wiki-index';
import { wikiLocaleFromPathname } from '$lib/features/wiki/logic/wiki-path';

// entries() zwraca tylko slugi EN — URL-e PL (natywne slugi) odkrywa crawler
// prerenderera przez anchory sidebara i switchera języka.
export const entries: EntryGenerator = () =>
	listEntrySlugs(getWikiIndex()).map((slug) => ({ slug }));

export const load: PageLoad = async ({ url, params }) => {
	const locale = wikiLocaleFromPathname(url.pathname);
	const hit = resolveWikiSlug(getWikiIndex(), locale, params.slug);
	if (hit === undefined) {
		error(404, 'Wiki page not found');
	}
	return {
		component: await loadWikiComponent(hit.page.filePath),
		page: hit.page,
		fallback: hit.fallback,
		// translations: hrefy switchera (z fallbackowymi URL-ami);
		// seoAlternates: tylko realne tłumaczenia (canonical/hreflang, SAM-552).
		translations: translationHrefs(getWikiIndex(), hit.page.pageId),
		seoAlternates: realTranslationHrefs(getWikiIndex(), hit.page.pageId)
	};
};
